import React from "react";
import { Heading ,T } from "../components/helpful";


export default class NewsLetter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle:<T value={"Newsletter"} /> ,
      hotelImg: 0,
      desc: <T value={"Suscribe to our Newsletter"} />,
    };

    
  }
  subHeading = () => {
    return <>{this.state.desc}</>;
  }
  render() {
    return (
      <div>
        <div className="">
          <div>
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>

          <div className="main-content">
            
          </div>
        </div>
      </div>
    );
  }
}
